import PopupModel from './Models/PopupModel.js';
import MapModel from './Models/MapModel.js';
import MapController from './Controllers/MapController.js';
import QueryBuilder from './QueryBuilder.js';

let selectFields = ['incdttm', 'location', 'sdot_coldesc', 'pedcount', 'severitydesc', 'pedcylcount', 'injuries', 'fatalities', 'seriousinjuries', 'shape'];
let query = new QueryBuilder;

query.select(selectFields).where("year", "=", 2016);

axios.get(query.url())
.then(function(response) {
    let Map = new MapController(new MapModel( new PopupModel ));
    Map.show(response.data);
    document.getElementById('spinner').classList.toggle('off');
})
.catch(function (error) {
    document.getElementById('map').innerHTML = '<span class="error">Unable to connect to <a href="http://data.seattle.gov/resource/v7k9-7dn4.json" target="_blank">data.seattle.gov</a> data feed. Please try again later.</span>';
    document.getElementById('spinner').classList.toggle('off');
});

// new Vue({
//     el: '#app',
//     components: {
//         'map': Map
//     }
// })


// WEBPACK FOOTER //
// ./js/app.js